import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

/**
 * Compute days overdue from an ISO date string (yyyy-mm-dd).
 * Returns a positive integer when overdue, 0 if due today or no date, negative if in the future.
 */
export function daysOverdue(dataScadenzaIso) {
    if (!dataScadenzaIso) return 0;
    try {
        const scad = new Date(String(dataScadenzaIso).slice(0, 10) + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const diff = Math.floor((today - scad) / (1000 * 60 * 60 * 24));
        return diff;
    } catch {
        return 0;
    }
}

/**
 * Prominent red "Scaduta da N giorni" badge.
 * - size: 'sm' (table) | 'md' (card)
 * - showDays: when true and data_scadenza is past, appends "da N giorni"
 */
export function OverdueBadge({ dataScadenza, size = 'sm', className = '', showDays = true, ...rest }) {
    const { t } = useTranslation();
    const days = daysOverdue(dataScadenza);
    if (days < 1) return null;
    const sizeClasses = size === 'md'
        ? 'text-xs px-2.5 py-1 gap-1.5'
        : 'text-[10px] px-2 py-0.5 gap-1';
    const iconSize = size === 'md' ? 'w-3.5 h-3.5' : 'w-3 h-3';
    const label = showDays
        ? t('common.overdue_by_days', { count: days, defaultValue: `Scaduta da ${days}g` })
        : t('common.overdue_label', { defaultValue: 'Scaduta' });
    return (
        <span
            className={`inline-flex items-center font-bold rounded-md bg-[hsl(0_75%_45%)] text-white shadow-sm ${sizeClasses} ${className}`}
            data-testid="overdue-badge"
            title={label}
            {...rest}
        >
            <AlertTriangle className={`${iconSize} flex-shrink-0`} />
            {label}
        </span>
    );
}
